
import React, { useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";

interface SupabaseStatusCheckProps {
  setSupabaseStatus: (status: string) => void;
}

export function SupabaseStatusCheck({ setSupabaseStatus }: SupabaseStatusCheckProps) {
  useEffect(() => {
    if (window.supabaseClient) {
      const checkSupabase = async () => {
        try {
          const response = await supabase
            .from('subscriptions')
            .select('count');
          
          if (response.error) {
            console.error("Supabase table check error:", response.error);
            setSupabaseStatus(`Error: ${response.error.message}`);
          } else {
            console.log("Supabase table check success:", response);
            setSupabaseStatus(`Connected, table exists`);
          }
        } catch (err) {
          console.error("Supabase check failed:", err);
          setSupabaseStatus(`Connection error: ${err instanceof Error ? err.message : String(err)}`);
        }
      };
      
      checkSupabase();
    } else {
      console.warn("No Supabase client detected in window object");
      setSupabaseStatus("Not connected");
    }
  }, [setSupabaseStatus]);

  return null; // This is a utility component, it doesn't render anything
}
